export const isBrowser = PLATFORM === 'browser'
export const isDevelopment = NODE_ENV === 'development'
export const isIos = PLATFORM === 'ios'
export const isAndroid = PLATFORM === 'android'
